// BM-H398 - s5_structure. `chosen_structure` selects C-14a / C-14b / C-14c
// (or the `structure_discuss` hard stop). The acknowledgements are the ones
// the engine reads for its cohabitee and RNRB warnings.

import { QuestionRow, SectionIntro, Select, YesNo, sectionProps } from "./fields";
import { STRUCTURES } from "./willsPayload";
import { CallbackHint, UnsupportedNotice } from "./removedOptions";

export const STRUCTURE_OPTIONS = [
  { value: STRUCTURES.A, label: "Outright to the people I name" },
  { value: STRUCTURES.B, label: "On trust for someone to enjoy during their lifetime, then to others" },
  { value: STRUCTURES.C, label: "On a nil rate band discretionary trust, for tax planning" },
  { value: STRUCTURES.DISCUSS, label: "I am not sure. Please talk it through with me" },
];

export default function S5Structure({ section, setSection, answers }) {
  const { s, set, nk, setNk } = sectionProps(section, setSection);
  const cohabiting = (answers || {}).s1_testator?.relationship_status === "cohabiting";

  return (
    <div data-testid="section-s5_structure">
      <UnsupportedNotice answers={answers} section="s5_structure" />
      <SectionIntro title="How your estate should pass">
        The residue is everything left after specific gifts, debts, taxes and expenses. There are three main ways to leave it. If you cannot decide from the questionnaire alone, choose to discuss it and your fee earner will walk you through the choice.
      </SectionIntro>

      <QuestionRow qid="s5_structure.has_spouse_or_partner_beneficiary" label="Will your spouse, civil partner or partner benefit under your will?" notKnown={nk("has_spouse_or_partner_beneficiary")} onNotKnown={(on) => setNk("has_spouse_or_partner_beneficiary", on)}>
        <YesNo testid="s5-spouse-partner-beneficiary" value={s.has_spouse_or_partner_beneficiary} disabled={nk("has_spouse_or_partner_beneficiary")} onChange={(v) => set({ has_spouse_or_partner_beneficiary: v })} />
      </QuestionRow>

      {cohabiting && s.has_spouse_or_partner_beneficiary === true && (
        <QuestionRow qid="s5_structure.cohabitee_iht_acknowledged" label="Do you understand that no inheritance tax spouse exemption applies to what you leave your partner?">
          <YesNo testid="s5-cohabitee-ack" value={s.cohabitee_iht_acknowledged} onChange={(v) => set({ cohabitee_iht_acknowledged: v })} />
        </QuestionRow>
      )}

      <QuestionRow qid="s5_structure.chosen_structure" label="How would you like the rest of your estate to pass?" notKnown={nk("chosen_structure")} onNotKnown={(on) => setNk("chosen_structure", on)}>
        <Select testid="s5-chosen-structure" value={s.chosen_structure} disabled={nk("chosen_structure")} options={STRUCTURE_OPTIONS} onChange={(v) => set({ chosen_structure: v })} />
      </QuestionRow>

      {s.chosen_structure === STRUCTURES.C && (
        <QuestionRow qid="s5_structure.rnrb_impact_acknowledged" label="Do you understand that the residence nil rate band may be affected by this structure?">
          <YesNo testid="s5-rnrb-ack" value={s.rnrb_impact_acknowledged} onChange={(v) => set({ rnrb_impact_acknowledged: v })} />
        </QuestionRow>
      )}

      {/* BM-H3636: the client-facing opt-out is gone. Every Will carries the firm's own administrative powers;
          a client who wants them changed is routed to a fee earner. A saved opt-out is kept and flagged above. */}
      <CallbackHint testid="s5-admin-powers-hint">Every Will includes a standard set of administrative powers for your trustees.</CallbackHint>
    </div>
  );
}
